(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-carousel"] && !Shopify.designMode) return;
  try {
    
  class PromoCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.promo-carousel__track');
      this.querySelector('.promo-carousel__arrow--prev')?.addEventListener('click', () => this.scrollBy(-1));
      this.querySelector('.promo-carousel__arrow--next')?.addEventListener('click', () => this.scrollBy(1));
    }
    scrollBy(dir) {
      if (!this.track) return;
      const slide = this.track.querySelector('.promo-carousel__slide');
      const step = slide ? slide.getBoundingClientRect().width + 16 : 300;
      this.track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
    }
  }
  if (!customElements.get('promo-carousel')) customElements.define('promo-carousel', PromoCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-products"] && !Shopify.designMode) return;
  try {
    
  class TabbedProducts extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.tabbed-products__tab'));
      this.panels = Array.from(this.querySelectorAll('.tabbed-products__panel'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.tabIndex));
      });
    }

    activate(index) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.tabIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        const active = panel.dataset.panelIndex === index;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }
  }

  if (!customElements.get('tabbed-products')) {
    customElements.define('tabbed-products', TabbedProducts);
  }

  } catch(e) { console.error(e); }
})();
})();
